module.exports = __webpack_public_path__ + "static/assets/ef4a998a82a8567de018baa4607bc6a0.svg";